module.exports = __webpack_public_path__ + "static/media/rotate.aaa7d450.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/JoinProfile/rotate.png
// module id = 612
// module chunks = 0